import { AppFunctionComponent } from "../../../types"
import React, { FocusEvent } from "react"
import Input from "./input.component"
import InputProps from "./input.interface"
import { ErrorMessage } from "../../../components/common/general-styles.component"
import { uniqueId } from "lodash"

interface InputWithErrorProps extends InputProps {
  error?: string
}

const InputWithError: AppFunctionComponent<InputWithErrorProps> = ({
  className,
  error,
  onFocus,
  onBlur,
  ...props
}) => {
  const focus = (event: FocusEvent<HTMLInputElement>) => {
    if (onFocus) {
      onFocus(event)
    }
  }

  const blur = (event: FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(event)
    }
  }

  const errorId = `id-${uniqueId()}-error`

  return (
    <span className={className}>
      <Input
        {...props}
        error={error}
        onFocus={focus}
        onBlur={blur}
        aria-describedby={errorId}
      />
      {error && <ErrorMessage id={errorId}>{error}</ErrorMessage>}
    </span>
  )
}

export default InputWithError
